import axios from 'axios';

export const findTreatmentById = (headers, id) => {
  return axios.get(`${process.env.REACT_APP_INFO_API_URL}/treatments/${id}`, {
    headers,
  });
};

export const updateTreatment = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_INFO_API_URL}/treatments/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteTreatment = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_INFO_API_URL}/treatments/${id}`,
    {
      headers: headers,
    },
  );
};
